import { jsx as _jsx } from "react/jsx-runtime";
import { isAndroid, isIOS } from 'react-device-detect';
import { BroadcasterView } from '../components/views/BroadcasterView';
import { BroadcasterViewMobile } from '../components/views/BroadcasterViewMobile';
import { EmbeddedView } from '../components/views/EmbeddedView';
import { ViewerView } from '../components/views/ViewerView';
import { ViewerViewMobile } from '../components/views/ViewerViewMobile';
import { useStreamDirection } from '../state/streamState';
import { useRequiredParam } from '../utils/url';
export function StreamPage({ embedded }) {
    const streamId = useRequiredParam('streamId');
    const streamDirection = useStreamDirection(streamId);
    if (embedded) {
        return _jsx(EmbeddedView, { streamId: streamId });
    }
    if (isIOS || isAndroid) {
        return streamDirection === 'outgoing' ? (_jsx(BroadcasterViewMobile, { streamId: streamId })) : (_jsx(ViewerViewMobile, { streamId: streamId }));
    }
    return streamDirection === 'outgoing' ? (_jsx(BroadcasterView, { streamId: streamId })) : (_jsx(ViewerView, { streamId: streamId }));
}
